import axios from '@/api/$axios'
export default {
  list ({ teacherId, page, perPage, kw, locked, unlocked }) {
    return axios.get(`/teachers/${teacherId}/courses`, {
      params: {
        page, perPage, name: kw, locked, unlocked
      }
    })
  },
  detail ({ id }) {
    return axios.get(`/courses/${id}`)
  }
}
